module.exports = __webpack_public_path__ + "b02bc5f379916938ea38534ccf3a2cd2.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/beirat-woltmershausen.svg
// module id = 944
// module chunks = 0